/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Auto_Time_AudioInputs */



/**
* | output |
* | --- |
* | "Calculate Timing by Audio Duration" |
*
* @param {Context_Menu_Auto_Time_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_auto_time_audio = /** @type {((inputs?: Context_Menu_Auto_Time_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Auto_Time_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Calculer le minutage par durée audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitberechnung anhand der Audiodauer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Calcola il tempo in base alla durata dell'audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расчет времени по длительности звука")
	if (locale === "es") return /** @type {LocalizedString} */ ("Calcular el tiempo por duración del audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("根据音频时长计算时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオの長さからタイミングを計算する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो अवधि के आधार पर समय की गणना करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Calcular a duração com base na duração do áudio")
	return /** @type {LocalizedString} */ ("Calculate Timing by Audio Duration")
});